<template>
  <div>
    <div class="w-full bg-blue-100">
      <div class="flex flex-col bg-gray-50 min-h-screen" data-testid="my-students-layout">
        <top-menu
          :sections="sections"
          :title="title"
          :show-popup-menu="!showSideMenu"
          :toast-menu="toastMenu"
          data-test-id="top-menu"
        />
        <section class="flex flex-start flex-col md:flex-row">
          <sidebar-menu
            v-if="showSideMenu"
            class="block"
            :title="'My Students'"
            :sections="sections"
            data-test-id="sidebar-menu"
          />

          <my-students-search-component :key="algoliaInstantSearchKey" />
        </section>
      </div>
      <div v-if="loading" class="absolute left-0 top-0 w-screen h-screen bg-white z-[100]">
        <spinner class="min-h-screen items-center" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, provide, ref } from "vue";

import { useRoute } from "vue-router";

import MyStudentsSearchComponent from "./MyStudentsSearchComponent.vue";
import { useTenantEntityManager } from "@/composables/useTenantManager";
import { useMyStudentsNavigation } from "./composables/useMyStudentsNavigation";
import Spinner from "@/components/helpers/Spinner.vue";
import SidebarMenu from "./Navigation/SidebarMenu.vue";
import TopMenu from "./Navigation/TopMenu.vue";

const route = useRoute();

const { getSelectedEntityView } = useTenantEntityManager();
const { sections, title, toastMenu, showSideMenu } = useMyStudentsNavigation();

const algoliaInstantSearchKey = computed(() => {
  const entity_id = getSelectedEntityView.value?.id ?? "";
  return `${route?.path}-${route?.query?.exchange_mode}-${entity_id}`;
});

const loading = ref(false);

const setLoading = (isLoading) => {
  loading.value = isLoading;
  if (isLoading) {
    window.scrollTo(0, 0);
  }
};

provide("setLoading", setLoading);
</script>
